<div class="card-layout">
  <!-- Header Section -->
  <div class="d-flex flex-row align-items-center psic-gap-4">
    <img
      src="../../../../assets/images/payment-info/payment-history.svg"
      alt="payment-history"
      class="card-image"
    />
    <div class="card-header">Payment History</div>
    @if (isLoading()) {
    <app-card-loader></app-card-loader>
    }
  </div>

  @if (!isLoading() && !dcBillingFailed) {
  <div class="separator"></div>
  <div class="d-flex flex-column psic-gap-6">
    <lib-single-selector
      [field]="historyField"
      (callback)="handleTabSelected($event)"
    ></lib-single-selector>

    <!-- Payment History Section -->
    @if (activeTab() === 'payments') { @if (paymentHistoryCount() > 0) { @for (payment of
    paymentHistoryList(); track payment.entryDate + payment.amount) {
    <div class="d-flex flex-column">
      <div
        class="d-flex flex-row justify-content-between align-items-center"
        [class.psic-p-2]="isMobile()"
      >
        @if (isMobile()) {
        <span class="caption-bold">{{ payment.entryDate | date : 'MM/dd/yyyy' }}</span>
        } @else {
        <p class="alt-bold">{{ payment.entryDate | date : 'MM/dd/yyyy' }}</p>
        }
        <div
          class="d-flex flex-row align-items-center"
          [class.psic-gap-2]="isMobile()"
          [class.psic-gap-6]="!isMobile()"
        >
          @if (payment.amount) {
          <div class="d-flex flex-column text-right">
            <span class="caption-bold text-right"> {{ formatAmount(payment?.amount) }}</span>
            @if(!isMobile()){
            <div class="d-flex flex-row align-items-center psic-gap-2">
              <span class="caption">{{ payment.displayPaymentMethod }}</span>
              <span class="caption">{{ payment.displayCardNumber }}</span>
            </div>
            }
          </div>
          }
        </div>
      </div>
      <div class="separator"></div>
    </div>
    } } @else {
    <lib-alert
      alertText="No payment history available."
      [alertTheme]="'default'"
      [alertType]="'small'"
    ></lib-alert>
    }

    <!-- Show more/less toggle -->
    @if (paymentHistoryCount() > showMoreDataLimit) {
    <div class="d-flex flex-row justify-content-center align-items-center">
      <lib-button
        [buttonText]="showMorePayments() ? 'Show less' : 'Show more'"
        buttonType="borderless"
        [libIcon]="showMorePayments() ? 'minus-circle' : 'add-circle'"
        (callback)="onShowPayments()"
      ></lib-button>
    </div>
    } }

    <!-- Refund History Section -->
    @if (activeTab() === 'refunds') { @if (refundHistoryCount() > 0) { @for (payment of
    refundHistoryList(); track payment.entryDate + payment.amount) {
    <div class="d-flex flex-column">
      <div
        class="d-flex flex-row justify-content-between align-items-center"
        [class.psic-p-2]="isMobile()"
      >
        @if (isMobile()) {
        <span class="caption-bold">{{ payment?.entryDate | date : 'MM/dd/yyyy' }}</span>
        } @else {
        <p class="alt-bold">{{ payment?.entryDate | date : 'MM/dd/yyyy' }}</p>
        }
        <div class="d-flex flex-row align-items-center psic-gap-2">
          @if (payment?.amount) {
          <div class="d-flex flex-column text-right">
            <span class="caption-bold text-right"> {{ formatAmount(payment?.amount) }}</span>
            @if (isMobile()) {
            <div class="d-flex flex-row align-items-center psic-gap-2">
              <span class="caption">{{ payment.displayPaymentMethod }}</span>
              <span class="caption">{{ payment.displayCardNumber }}</span>
            </div>
            }
          </div>
          }
        </div>
      </div>
      <div class="separator"></div>
    </div>
    } } @else {
    <lib-alert
      alertText="No refunds available."
      [alertTheme]="'default'"
      [alertType]="'small'"
    ></lib-alert>
    }

    <!-- Show more/less toggle -->
    @if (refundHistoryCount() > showMoreDataLimit) {
    <div class="d-flex flex-row justify-content-center align-items-center">
      <lib-button
        [buttonText]="showMoreRefunds() ? 'Show less' : 'Show more'"
        buttonType="borderless"
        [libIcon]="showMoreRefunds() ? 'minus-circle' : 'add-circle'"
        (callback)="onShowRefunds()"
      ></lib-button>
    </div>
    } }
  </div>
  }
  <!-- end @else loading -->
</div>
